export const charmap = {
  arealtype: {
    11: 'c', // Bebygd
    81: 'f', // Ferskvann
    21: '=', // Fulldyrka jord
    82: 'h', // Hav
    99: '-', // Ikke kartlagt
    23: '6', // Innmarksbeite
    60: '1', // Myr
    22: '5', // Overflatedyrka jord
    12: 'z', // Samferdsel
    30: 'w', // Skog
    70: 'ø', // Snøisbre
    50: 'å' // Åpen fastmark
  },
  treslag: {
    31: '*', // Barskog
    32: '0', // Lauvskog
    33: 'x', // Blandingsskog
    35: 'a', // Lauvblandingsskog
    39: 'u', // Ikke tresatt
    98: '~', // Ikke relevant
    99: '-' // Ikke registrert
  },
  skogbonitet: {
    11: 'i', // Impediment
    12: 'L', // Lav
    13: 'M', // Middels
    14: 'H', // Høy
    15: 'S', // Særshøy
    17: 'P', // Produktiv
    18: 'W', // Høyogsærshøy
    98: '~', // Ikke relevant
    99: '-' // Ikke registrert
  },
  grunnforhold: {
    41: 'r', // Blokkmark
    42: 'd', // Fjell i dagen
    43: 'g', // Grunnlendt
    44: 'j', // Jorddekt
    45: 'o', // Organiske jordlag
    46: 'e', // Konstruert
    98: '~', // Ikke relevant
    99: '-' // Ikke registrert
  }
};
